import { Icon } from '@iconify/react'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PatientListfilter, getPatientDetails, getPatientList } from '../redux/actions/passActions'
import Pagination from './pagination'
import Avatar from './shared/chat/avatar'
import Table from './shared/table'
import { getfilterData, togglePatientDetail } from '../redux/slices/filter'
import { Badge, Dropdown, Label, Select, Spinner, Accordion, FloatingLabel } from 'flowbite-react'
import { Menu, Listbox } from '@headlessui/react'
import { backendURL } from '../config/api'
import { AiOutlineEye } from 'react-icons/ai'
import { TbUrgent } from "react-icons/tb";
import { CityCodes } from './shared/CityCode'
import { unToogleFilter } from '../redux/slices/chat'
import { toastError } from '../utils/helpers/methods'
import PatientFilters from './shared/PatientFilter'
import PatientListTour from './PatientListTour'

const PatientList = () => {
  const { userToken, userInfo } = useSelector((state) => state.auth)
  const { filterData, ispatientDetail } = useSelector((state) => state.filter)
  const { PatientListinfo, PatientList, Patientfilter } = useSelector(
    (state) => state.pass
  )

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  let patientUrl = `${backendURL}/img/patient`

  const [PatientFilterval, setPatientFilterval] = useState({
    group: '',
    tag: '',
    search: '',
    patient_login: '1',
    dob: '',
    status: 'active',
    locations: [],
    team: []
  })
  
  const [selectedLocations, setSelectedLocations] = useState([])
  const [selectedTeams, setSelectedTeams] = useState([])
  const [selectedGroupName, setSelectedGroupName] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [startTour, setStartTour] = useState(false)

  useEffect(() => {
    const handleStartTour = () => setStartTour(true);
    window.addEventListener('trigger-active-tour', handleStartTour);
    
    return () => {
      window.removeEventListener('trigger-active-tour', handleStartTour);
    };
  }, []);

  useEffect(() => {
    setIsLoading(true)
    const timer = setTimeout(() => setIsLoading(false), 2000)
    return () => clearTimeout(timer)
  }, [PatientList])

  useEffect(() => {
    const data = location?.state

    if (ispatientDetail && filterData) {
      setPatientFilterval({
        group: filterData.group || '',
        tag: filterData.tag || '',
        search: filterData.search || '',
        patient_login: filterData.patient_login || '1',
        dob: filterData.dob || '',
        status: filterData.status || 'active',
        locations: filterData.locations || [],
        team: filterData.team || []
      })
      setSelectedLocations(filterData.locations || [])
      setSelectedTeams(filterData.team || [])
      setSelectedGroupName(filterData.groupName || '')

      dispatch(getPatientList({
        token: userToken,
        practitioner_id: userInfo.id,
        employer_filter: filterData.groupName || '',
        patient_tag: filterData.tag || '',
        search_key: filterData.search || '',
        page: 1,
        patient_login: filterData.patient_login || '1',
        dob: filterData.dob || '',
        status: filterData.status || 'active',
        locations: filterData.locations || [],
        team: filterData.team || []
      }))
    } else if (data?.option) {
      setPatientFilterval((prev) => ({ ...prev, patient_login: data.option }))
      dispatch(getPatientList({
        token: userToken,
        practitioner_id: userInfo.id,
        employer_filter: '',
        patient_tag: '',
        limit: 5,
        patient_login: data.option,
        dob: '',
        status: '',
        locations: [],
        team: []
      }))
    } else if (data?.search_key) {
      setPatientFilterval((prev) => ({ ...prev, search: data.search_key }))
      dispatch(getPatientList({
        token: userToken,
        practitioner_id: userInfo.id,
        employer_filter: '',
        patient_tag: '',
        search_key: data.search_key,
        limit: 5,
        patient_login: data.option,
        dob: '',
        status: '',
        locations: [],
        team: []
      }))
    } else {
      dispatch(getPatientList({
        token: userToken,
        practitioner_id: userInfo.id,
        employer_filter: '',
        patient_tag: '',
        search_key: data ? data : '',
        limit: 5,
        patient_login: '1',
        dob: '',
        status: 'active',
        locations: [],
        team: []
      }))
    }

    dispatch(PatientListfilter({ practitioner_id: userInfo.id, token: userToken }))

    setTimeout(() => {
      dispatch(togglePatientDetail(false))
    }, 500)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (filterData && Patientfilter) {
      if (filterData.groupName) setSelectedGroupName(filterData.groupName)
      if (filterData.locations?.length > 0) setSelectedLocations(filterData.locations)
      if (filterData.team?.length > 0) setSelectedTeams(filterData.team)
    }
    //eslint-disable-next-line
  }, [Patientfilter])

  const formatDOBToUS = (dob) => {
    if (!dob) return ''
    if (dob.includes('-')) {
      const [year, month, day] = dob.split('-')
      return `${month}/${day}/${year}`
    }
    return dob
  }


  const handlefilter = () => {
    dispatch(getfilterData({ ...PatientFilterval, groupName: selectedGroupName }))
    dispatch(getPatientList({
      token: userToken,
      practitioner_id: userInfo.id,
      employer_filter: selectedGroupName,
      patient_tag: PatientFilterval.tag,
      search_key: PatientFilterval.search,
      patient_login: PatientFilterval.patient_login,
      dob: PatientFilterval.dob,
      status: PatientFilterval.status,
      team: PatientFilterval.team,
      locations: PatientFilterval.locations,
      page: 1,
    }))
    setCurrentPage(1)
  }

  const handleResetFilters = () => {
    setPatientFilterval({
      group: '',
      tag: '',
      search: '',
      patient_login: '',
      dob: '',
      status: '',
      locations: [],
      team: []
    })
    setSelectedLocations([])
    setSelectedTeams([])
    setSelectedGroupName('')
    setCurrentPage(1)
    dispatch(getfilterData({}))
    dispatch(getPatientList({
      token: userToken,
      practitioner_id: userInfo.id,
      employer_filter: '',
      patient_tag: '',
      search_key: '',
      page: 1,
      patient_login: '',
      dob: '',
      status: '',
      locations: [],
      team: []
    }))
  }

  function handlePageChange(pageNumber) {
    setCurrentPage(pageNumber)
    dispatch(getPatientList({
      token: userToken,
      practitioner_id: userInfo.id,
      employer_filter: selectedGroupName,
      patient_tag: PatientFilterval.tag,
      search_key: PatientFilterval.search,
      page: pageNumber,
      patient_login: PatientFilterval.patient_login,
      dob: PatientFilterval.dob,
      status: PatientFilterval.status,
      locations: PatientFilterval.locations,
      team: PatientFilterval.team
    }))
  }

  const gotoChat = async (findChat) => {
    const response = await dispatch(getPatientDetails({ token: userToken, patientId: findChat.id })).unwrap()
    if (response?.data?.data) {
      const user = response.data.data.patient_login?.sendbird_user_id
      if (user != null) {
        dispatch(unToogleFilter())
        navigate('/chat', { state: response.data.data })
      } else {
        toastError("Not able to chat at this moment.")
      }
    } else {
      toastError("Something went wrong.")
    }
  }

  const viewDetail = () => dispatch(togglePatientDetail(true))

  const columns = [
    {
      header: '',
      cell: (row) => (
        <Link to={`/patientDetails/${row.id}`} onClick={viewDetail}>
          <Avatar
            fname={!row.address.profile_image && row.address.first_name}
            lname={!row.address.profile_image && row.address.last_name}
            image={row.address.profile_image ? `${patientUrl}/${row.address.profile_image}` : ''}
            className={'hover:cursor-pointer'}
            showStatus={false}
          />
        </Link>
      )
    },
    {
      header: 'Name',
      cell: (row) => (
        <Link
          to={`/patientDetails/${row.id}`}
          className='text-everglade-800 font-bold py-2 px-3 mx-2 rounded'
          onClick={viewDetail}
        >
          <div className='flex flex-row'>
            {row?.address?.first_name + ' ' + row?.address?.last_name}
            {row?.is_vip === 1 && (
              <Icon className="ml-2 mb-2" icon="quill:vip" fontSize={30} color='#ffbf00' />
            )}
          </div>
        </Link>
      )
    },
    {
      header: 'DOB',
      cell: (row) => <>{formatDOBToUS(row?.address?.dob)}</>
    },
    {
      header: 'Status',
      cell: (row) => (
        <div className='tour-list-status flex flex-row'>  
          <Badge color={(row?.deleted_at === '' || row?.deleted_at == null) ? 'success' : 'failure'}>
            {(row?.deleted_at == null || row?.deleted_at === '') ? 'Active' : 'InActive'}
          </Badge>
        </div>
      )
    },
    {
      header: 'Location',
      cell: (row) => (
        <div className='flex flex-row'>
          {row?.patientlocation?.length > 0 ? (
            <div className="bg-red-800 text-white rounded">
              <span className="text-white m-1 uppercase font-bold">
                {CityCodes[row?.patientlocation[0]?.location_name] || row?.patientlocation[0]?.location_name}
              </span>
            </div>
          ) : '-'}
        </div>
      )
    },
    {
      header: 'Current Employer',
      cell: (row) => (
        <div className='flex flex-row'>
          {row?.location_group?.group_name && (
            <span className="badge info">{row?.location_group?.group_name}</span>
          )}
        </div>
      )
    },
    {
      header: 'Relationship',
      cell: (row) => <span className='tour-list-relationship'>{row?.address?.relationship}</span>
    },
    {
      header: 'Urgent Request',
      cell: (row) => (
        <>
          {row?.patient_login?.urgent_button === 1 ? (
           <TbUrgent fontSize={30} className='text-red-500 cursor-pointer animate-pulse' /> //onClick={() => gotoChat(row)} 
          ) : (
            <span>-</span>
          )}
        </>
      )
    },
    {
      header: 'Chat',
      cell: (row) => (
        <>
          {row?.patient_login !== null &&
           row?.patient_login?.sendbird_user_id &&
           row?.practice?.def_provider_id ? (
            <Icon
              icon='humbleicons:chat'
              fontSize={30}
              className='tour-chat-button text-everglade-500 cursor-pointer'
              onClick={() => gotoChat(row)}
            />
          ) : (
            <span>-</span>
          )}
        </>
      )
    },
    {
      header: 'View',
      cell: (row) => (
        <div className='text-sm text-everglade-800'>
          <Link
            to={`/patientDetails/${row.id}`}
            className='tour-list-view text-everglade-800 font-bold py-2 px-3 mx-2 rounded'
            onClick={viewDetail}
          >
            <AiOutlineEye size={24} className='cursor-pointer' />
          </Link>
        </div>
      )
    }
  ]

  return (
    <div className='w-full'>
      <PatientListTour 
        isLoading={isLoading} 
        hasPatients={PatientList?.length > 0}
        forceStart={startTour}
        onTourEnd={() => setStartTour(false)}
      />
      
      <div className='w-full h-full overflow-x-hidden'>
        <div className='mx-auto'>
          <section>
            <Table
              loader={isLoading}
              count={0}
              defaultPage={1}
              page={currentPage}
              onChange={handlePageChange}
              totalPages={PatientListinfo?.data?.total_pages}
              columns={columns}
              data={PatientList || []}
              header={() => (
                <section className='w-full grid grid-cols-1 lg:grid-cols-1 gap-3 justify-between items-center'>
                  <h1 className='text-base w-[100px] font-semibold text-everglade-900 pl-2 shrink-0'>
                    Patient List
                  </h1>

                  {PatientList && (
                    <div className="tour-list-filters w-full">
                      <PatientFilters
                        filterVal={PatientFilterval}
                        setFilterVal={setPatientFilterval}
                        Patientfilter={Patientfilter}
                        selectedLocations={selectedLocations}
                        selectedTeams={selectedTeams}
                        onLocationsChange={setSelectedLocations}
                        onTeamsChange={setSelectedTeams}
                        onFilter={handlefilter}         
                        onReset={handleResetFilters}
                        onGroupNameChange={setSelectedGroupName} 
                      />
                    </div>
                  )}
                </section>
              )}
            />

            {PatientList?.length > 0 && (
              <div className='tour-list-pagination pagination my-3 flex justify-center pr-4 w-full md:justify-end'>
                {PatientListinfo?.data?.total_pages > 0 && !isLoading && (
                  <Pagination
                    count={10}
                    defaultPage={1}
                    page={currentPage}
                    onChange={handlePageChange}
                    totalPages={PatientListinfo?.data?.total_pages}
                    totalCount={PatientListinfo?.data?.total_count}
                  />
                )}
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  )
}

export default PatientList